/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../objects/context.js';
import ko from 'knockout';


class workspaceNavModel {

    constructor(params) {
        // Profile
        this.componentName = "workspace-nav";
        this.context = context;
        this.id = this.context.util.guid();
        this.visible = ko.observable(true);

        this.homeActive = ko.observable("active");
        this.myJobsNavActive = ko.observable("");
        this.optionsNavActive = ko.observable("");
        this.helpNavActive = ko.observable("");

        this.editJobTitle = ko.observable(false);

        this.context.eventManager.subscribe((navObj) =>{
            this.handleNavChanged(navObj);
        },this, "navChanged");


    }

    processNav(item,select,param) {
        
        console.log("workspace-nav:processNav: item: %o", item);
        //this.diableNav();

        this.context.eventManager.notifySubscribers(item,"navChanged");
    }


    handleNavChanged(navObj) {

        this.clearNav();

        switch(navObj) {

            case 'home':
            this.homeActive("active");
            break;

            case 'jobList':
            this.myJobsNavActive("active");
            break;

            case 'options':
            this.optionsNavActive("active");
            break;

            case 'help':
            this.helpNavActive("active");
            break;

        }
    }

    clearNav() {
        this.homeActive("");
        this.myJobsNavActive("");
        this.optionsNavActive("");
        this.helpNavActive("");
    }

    saveChanges() {
        console.log("Save Changes:");

    }



}

export default { viewModel: workspaceNavModel, template: require('!raw-loader!./workspace-nav.html') };


// WEBPACK FOOTER //
// ./src/components/workspace-nav/workspace-nav.js